import axios from "axios";
import { debounce } from "lodash";
import React, { useEffect, useState } from "react";
import Icon from '@ant-design/icons';
import FoodSVG from '../../assets/svg/food.svg';
import {Image, Tooltip} from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBowlFood, faMugSaucer, faPizzaSlice } from "@fortawesome/free-solid-svg-icons";
import "../../styles/OrderHistoryStyle.css";

export default function AggretgatedOrderData() {
  const [totalBreakFastOrdered, setTotalBreakFastOrdered] = useState(0);
  const [totalLunchOrdered, setTotalLunchOrdered] = useState(0);
  const base_url = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const accessToken = sessionStorage.getItem("accessToken");
        const user_id = sessionStorage.getItem("userData");

        const response = await axios.get(
          `${base_url}/api/v1/client/order/total-orders/${user_id}`,
          {
            headers: { Authorization: `Bearer ${accessToken}` },
            params: {
              page: 1,
            },
          }
        );

        const { data } = response;
        setTotalBreakFastOrdered(
          data.data.lunchAndBreakfastOrderCount.total_breakfast
        );
        setTotalLunchOrdered(
          data.data.lunchAndBreakfastOrderCount.total_lunch
        );
      } catch (error) {
        console.log(error);
        // Handle error state or display an error message
      }
    };

    const debouncedFetchData = debounce(fetchData, 200); // Adjust the debounce delay as needed
    debouncedFetchData();
    return () => {
      // Cancel the debounced function when the component unmounts
      debouncedFetchData.cancel();
    };
  }, []);

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-md-10 col-lg-10 order-history-glimps">
          <div className="stat-parent">
            <Tooltip placement="bottom" title={'Total Meal Ordered'}>
              <div className="stat-child">
                <FontAwesomeIcon icon={faBowlFood} className="child-icon cl-blue"/>
                <div>{parseInt(totalBreakFastOrdered) + parseInt(totalLunchOrdered)}</div>
              </div>
            </Tooltip>
            <div>=</div>
            <Tooltip placement="bottom" title={'Breakfast Ordered'}>
              <div className="stat-child">
                <FontAwesomeIcon icon={faMugSaucer} className="child-icon cl-orange"/>
                <div>{parseInt(totalBreakFastOrdered)}</div>
              </div>
            </Tooltip>
            <div>+</div>
            <Tooltip placement="bottom" title={'Lunch Ordered'}>
              <div className="stat-child">
                <FontAwesomeIcon icon={faPizzaSlice} className="child-icon cl-green"/>
                <div>{parseInt(totalLunchOrdered)}</div>
              </div>
            </Tooltip>
          </div>
        </div>
      </div>
    </div>
  );
}
